'use strict';

var PanelGroups = function(config) {
  var self = this;
  var $toggle = $(config.panelGroupToggle);
  var $panelGroup = $(config.panelGroup);
  var $navToggle = $(config.navToggle);

  self.parseButtons = function() {
    $toggle.each(function() {
      var $this = $(this);
      var _$currentPanelGroup = $($this.attr('data-chronology-panel-group'));
      var currentYear = $this.attr('data-year');

      self.clickHandler($this, _$currentPanelGroup, currentYear);
    });
  }

  self.clickHandler = function(_$toggle, _$currentPanelGroup, currentYear) {
    var cb = function() {
      if (_$toggle.is(config.panelGroupPrevNextButton)) {
        setTimeout(function () {
          self.syncNav(_$toggle);
        }, 300);
      }
    };
    _$toggle.on('click.chronologyPanelGroups', function() {
      $toggle.removeClass('is-active');
      _$toggle.addClass('is-active');
      self.hidePanelGroups(_$currentPanelGroup, cb);
      self.showCurrentPanelGroup(_$currentPanelGroup, currentYear);
    });
  }

  self.hidePanelGroups = function(_$currentPanelGroup, cb) {
    $panelGroup
      .not(_$currentPanelGroup)
      .removeClass('is-visible')
      .velocity({
        opacity: 0
      },{
        duration: 0,
        display: 'none',
        complete: function() {
          if (typeof cb === 'function') {
            cb();
          }
        }
      });
  }

  self.showCurrentPanelGroup = function(_$currentPanelGroup, currentYear) {
    if (! _$currentPanelGroup.hasClass('is-visible')) {
      _$currentPanelGroup
        .velocity({
          opacity: 1
        },{
          easing: 'easeInCubic',
          display: 'block',
          duration: 860
        })
        .addClass('is-visible');
      $navToggle.attr('data-current-year', currentYear);
    }
  }

  self.syncNav = function(_$toggle) {
    var currGroupId = _$toggle.attr('data-chronology-panel-group');

    $(config.navListGroupToggle).each(function() {
      var $this = $(this);
      var groupId = $this.attr('data-chronology-panel-group');

      if (groupId === currGroupId) {
        $this.trigger('click');
      }
    });
  }

  self.init = function() {
    self.parseButtons();
  }
};

module.exports = PanelGroups;
